/**
 * @copyright © Paramount Streaming
 * @description Default server base URLs for the Pluto TV legacy adapter.
 */

/** Legacy channels metadata API base (browser). */
export const PLUTO_LEGACY_CHANNELS_URL = 'https://service-channels.clusters.pluto.tv';

/** Legacy VOD metadata API base (browser). */
export const PLUTO_LEGACY_VOD_URL = 'https://service-vod.clusters.pluto.tv';

/** Universal End Cards / up-next recommendation API base (browser). */
export const PLUTO_LEGACY_UEC_URL = 'https://api-web-pluto-us-stage.gcp-dev-usc1.pluto.tv';

/** next item **/
export const PLUTO_LEGACY_NEXT_ITEM_URL = 'https://api-web-pluto-us-stage.gcp-dev-usc1.pluto.tv'; // TODO

export const PLUTO_LEGACY_SERVERS = {
	channels: PLUTO_LEGACY_CHANNELS_URL,
	vod: PLUTO_LEGACY_VOD_URL,
	uec: PLUTO_LEGACY_UEC_URL,
	nextItem: PLUTO_LEGACY_NEXT_ITEM_URL
} as const;